import { render, staticRenderFns } from "./appLogDownload.vue?vue&type=template&id=22fd1151&scoped=true"
import script from "./appLogDownload.vue?vue&type=script&lang=js"
export * from "./appLogDownload.vue?vue&type=script&lang=js"
import style0 from "./appLogDownload.vue?vue&type=style&index=0&id=22fd1151&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd1151",
  null
  
)

export default component.exports